import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class NavOverviewDemoRequest {
  constructor(init) {
    if (isNil(init)) return undefined
    this._employee_id = init.employee_id
    this._requested_services = init.requested_services
    this._self_funding_status = init.self_funding_status
    this._current_pbm_provider = init.current_pbm_provider
    this._demo_contact_name = init.demo_contact_name
    this._demo_contact_email = init.demo_contact_email
    this._request_details = init.request_details
    this._number_of_employees = init.number_of_employees
    this._organization_name = init.organization_name
    this._user_email = init.user_email
    this._user_name = init.user_name
    this._user_phone_number = init.user_phone_number
    this._users_job_title = init.users_job_title
  }

  static shape = {
    employee_id: PropTypes.string.isRequired,
    requested_services: PropTypes.arrayOf(PropTypes.string).isRequired,
    self_funding_status: PropTypes.string.isRequired,
    current_pbm_provider: PropTypes.string.isRequired,
    demo_contact_name: PropTypes.string.isRequired,
    demo_contact_email: PropTypes.string.isRequired,
    request_details: PropTypes.string.isRequired,
    number_of_employees: PropTypes.number,
    organization_name: PropTypes.string.isRequired,
    user_email: PropTypes.string,
    user_name: PropTypes.string,
    user_phone_number: PropTypes.string,
    users_job_title: PropTypes.string
  }

  get employee_id() {
    return this._employee_id
  }

  get requested_services() {
    return this._requested_services
  }

  get self_funding_status() {
    return this._self_funding_status
  }

  get current_pbm_provider() {
    return this._current_pbm_provider
  }

  get demo_contact_name() {
    return this._demo_contact_name
  }

  get demo_contact_email() {
    return this._demo_contact_email
  }

  get request_details() {
    return this._request_details
  }

  get number_of_employees() {
    return this._number_of_employees
  }

  get organization_name() {
    return this._organization_name
  }

  get user_email() {
    return this._user_email
  }

  get user_name() {
    return this._user_name
  }

  get user_phone_number() {
    return this._user_phone_number
  }

  get users_job_title() {
    return this._users_job_title
  }
}

export default NavOverviewDemoRequest
